import React, { Component } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { Card, Pagination, Row, Col, Container } from 'react-bootstrap'

// Imports de imágenes
import img13 from '../Rehabilitacion/img13.jpg'
import img14 from '../Rehabilitacion/img14.jpg'
import img15 from '../Rehabilitacion/img15.jpg'
import img16 from '../Rehabilitacion/img16.jpg'
import img17 from '../Rehabilitacion/img17.jpg'
import img18 from '../Rehabilitacion/img18.jpg'
import img19 from '../Rehabilitacion/img19.jpg'
import img20 from '../Rehabilitacion/img20.jpg'
import img21 from '../Rehabilitacion/img21.jpg'
import img22 from '../Rehabilitacion/img22.jpg'
import img23 from '../Rehabilitacion/img23.jpg'
import img24 from '../Rehabilitacion/img24.jpg'

export class Rehabilitation2 extends Component {
    render() {
        const rehabItems = [
            { img: img13 }, { img: img14 }, { img: img15 },
            { img: img16 }, { img: img17 }, { img: img18 },
            { img: img19 }, { img: img20 }, { img: img21 },
            { img: img22 }, { img: img23 }, { img: img24 }
        ];

        return (
            <div>
                <Header />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Rehabilitation</h1>
                        </Col>
                    </Row>
                    <br />

                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item href="/en/Rehabilitation">{1}</Pagination.Item>
                        <Pagination.Item active>{2}</Pagination.Item>
                        <Pagination.Item href="/en/Rehabilitation3">{3}</Pagination.Item>
                    </Pagination>

                    {/* Implementación de 2 columnas para asegurar legibilidad del texto en imágenes */}
                    <Row className="justify-content-center g-4">
                        {rehabItems.map((item, idx) => (
                            <Col key={idx} xs={12} lg={6}>
                                <Card className="shadow-sm border-0 h-100">
                                    <Card.Body className="p-3">
                                        <Card.Img 
                                            variant="top" 
                                            src={item.img} 
                                            style={{ 
                                                width: '100%', 
                                                height: 'auto', 
                                                objectFit: 'contain' 
                                            }} 
                                        />
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                    <br />
                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item href="/en/Rehabilitation">{1}</Pagination.Item>
                        <Pagination.Item active>{2}</Pagination.Item>
                        <Pagination.Item href="/en/Rehabilitation3">{3}</Pagination.Item>
                    </Pagination>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}